import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../common/Button'
import { documentsTypes, practicesOptions } from '../../../../lib/systemData'
import InputBox from '../../../common/interactive/InputBox'
import { uploadDocumentApi } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { caseActions } from '../../../../store/case'
import { returnOnlyPracticesThatAreOnTheCase } from '../../../../lib/misc'

import CustomSelect from '../../../common/interactive/CustomSelect'
import CustomSelectMultiple from '../../../common/interactive/CustomSelectMultiple'

import classes from './DocumentsTabListItemUploading.module.css'
import { documentsActions } from '../../../../store/documents'
import DocumentEditable from './DocumentEditable'

const DocumentsTabListItemUploading = ({data, file, removeFile}) => {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    let types = documentsTypes()
    let practices = practicesOptions()

    const documentTypeId = useSelector(state => state.documents.documentTypeId)
    
    
    const [isLoading, setIsLoading] = useState(false)
    const [typeBySelect, setTypeBySelect] = useState(null)
    const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(documentTypeId)
    const [selectedDocumentTypeWhole, setSelectedDocumentTypeWhole] = useState(types.find(item => item.value == documentTypeId))
    const [documentNotes, setDocumentNotes] = useState('')
    const [selectedPractices, setSelectedpractices] = useState([])
    const [practicesFilteredOptions, setPracticesFilteredOptions] = useState([])

    const removefileHandler = () => {
        removeFile(data.id)
    }

    

    const saveFileHandler = async () => {
        setIsLoading(true)
        
        try {
            if (file) {
                let formData = new FormData();

                formData.append("file", file.file_to_upload);
                formData.append("notes", documentNotes);
                formData.append("document_type_id", selectedDocumentTypeId)
                formData.append("practices", selectedPractices.join(','))

                let reqBody = formData

                const upload = await uploadDocumentApi(userToken, activeCase.case.id, reqBody, dispatch)  

                if (upload?.errorMessage) {
                    dispatch(notificationActions.setError(upload))
                } else {
                    // /success 
          
                    removeFile(data.id)               
                
                    // add item to store dispatch
                    dispatch(caseActions.pushItemToDDocuments(upload))
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    const documentTypeHandler = (value) => {
        setSelectedDocumentTypeId(value.data.value)
        setSelectedDocumentTypeWhole(value)
        setTypeBySelect(value.option.data.type)

        if (value.data.value == 1 && practicesFilteredOptions) {
            setPracticesFilteredOptions([...practicesFilteredOptions, {
                label: 'All',
                value: 'all'
            }])
        } else {
            if (activeCase && activeCase.practices && activeCase.practices.length > 0) {
                let items = returnOnlyPracticesThatAreOnTheCase(activeCase, practices)
                setPracticesFilteredOptions(items)
            }
        }
    }

    const setNotesHandler = (value) => {
        setDocumentNotes(value.data.value ? value.data.value : '')
    }


    const changePracticesHandler = (value) => {
        setSelectedpractices(value.data.value)

    }

    useEffect(() => {
        if (activeCase && activeCase.practices && activeCase.practices.length > 0) {
            let items = returnOnlyPracticesThatAreOnTheCase(activeCase, practices)
            setPracticesFilteredOptions(items)
        }    

        return () => {
            dispatch(documentsActions.resetDocumentTypeId())
        }
    }, [activeCase])

    
    return <tr className={classes.tr}>
        {/* name of file and controls  */}
        <td>
            <div className='flex-vertical-center'>
                {data.file && <>{data.file}</>}
                <Button click={removefileHandler} btnStyle={'btn_simple'} color={'danger'}>
                    <i className='ti ti-trash'></i>
                    <span className='sr-only'>delete file</span>
                </Button>
            </div>
        </td>

        {/* ######## date is now because now was the time when the document was uplaoded! ######## */}
        <td>Now</td>


        {/* ######## user name ######## */}
        <td>{data.uploader && data.uploader}</td>
            
        <DocumentEditable data={data} file={file} removeFile={removeFile}/>
        
        {/* ######## document type ######## */}
        {/* <td>
            <CustomSelect optionsData={types} preSelectedValue={selectedDocumentTypeId} action={documentTypeHandler} sameSizeAsContainer={true}/>
        </td> */}
            
        {/* ######## practice --- this is available only if the type is practice ######## */}
        {/* <td>   
            {typeBySelect == 'Practice' && practicesFilteredOptions && <>
                <CustomSelectMultiple optionsData={practicesFilteredOptions} preSelectedValue={selectedDocumentTypeId} action={changePracticesHandler} sameSizeAsContainer={true}/>
            </>}
            {typeBySelect !== 'Practice' && <>-</>} 
        </td> */}

        {/* ######## notes ######## */}
        {/* <td className={classes.td_input}>
            <InputBox placeholder={'Write note here...'} action={setNotesHandler}/>
        </td> */}

        {/* ######## save document ######## */}
        {/* <td><Button btnStyle={'btn_small'} color={'white'} click={saveFileHandler} isLoading={isLoading} isDisabled={!selectedDocumentTypeWhole}><i className='ti ti-check'></i>Save</Button></td> */}
    </tr>
}

export default DocumentsTabListItemUploading